document.addEventListener('DOMContentLoaded', () => {
    const details = document.querySelectorAll('.rule-test');

    details.forEach((detail) => {
        const content = detail.querySelector('.faq-item__body');
        const summary = detail.querySelector('.summary-metafiel-pdp');
        let animation = null;

        const animate = (open) => {
            // Cancel any running animation
            if (animation) {
                animation.cancel();
            }

            // Set initial state
            if (open) {
                detail.open = true;
            }

            // Get the start and end heights
            const startHeight = content.offsetHeight;
            const endHeight = open ? content.scrollHeight : 0;

            // If heights are the same, no need to animate
            if (startHeight === endHeight) {
                return Promise.resolve();
            }

            // Configure the animation
            animation = content.animate([
                { height: startHeight + 'px' },
                { height: endHeight + 'px' }
            ], {
                duration: 400,
                easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
                fill: 'both'
            });

            return animation.finished.then(() => {
                animation = null;
                if (!open) {
                    detail.open = false;
                }
                // Reset height to allow for dynamic content changes
                content.style.height = open ? 'auto' : '';
            });
        };

        summary.addEventListener('click', (e) => {
            e.preventDefault();

            // If animation is running, don't start another one
            if (animation) {
                return;
            }

            animate(!detail.open);
        });

        // Initialize open items
        if (detail.open) {
            content.style.height = 'auto';
        }
    });

    // Handle window resize for dynamic content
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            details.forEach(detail => {
                if (detail.open) {
                    const content = detail.querySelector('.faq-item__body');
                    content.style.height = 'auto';
                }
            });
        }, 100);
    });
});


// Track active timeouts
let disableTimeout;
let forceEnableTimeout;
let isDisabled = false; // Track disabled state

const setupObserver = () => {
    const variantContainer = document.querySelector('variant-selects');
    const selectElements = document.querySelectorAll('select.select__select');
    let observer;

    if (variantContainer) {
        const disableContainer = () => {
            if (isDisabled) return; // Prevent multiple disabling
            isDisabled = true;

            clearTimeout(disableTimeout);
            clearTimeout(forceEnableTimeout);

            // Disable and add visual feedback
            variantContainer.style.pointerEvents = 'none';
            variantContainer.style.cursor = 'wait';
            selectElements.forEach(select => {
                select.style.pointerEvents = 'none';
                select.style.cursor = 'wait';
            });

            // Re-enable after delay
            disableTimeout = setTimeout(() => {
                enableElements();
            }, 700);

            // Force enable as safety
            forceEnableTimeout = setTimeout(() => {
                enableElements();
            }, 2000);
        };

        observer = new MutationObserver(disableContainer);
        observer.observe(variantContainer, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['class', 'data-selected']
        });
    }
    return observer;
};

// Function to enable elements
const enableElements = () => {
    isDisabled = false;
    const elements = document.querySelectorAll('label, select.select__select, variant-selects');
    elements.forEach(el => {
        el.style.pointerEvents = 'auto';
        el.style.cursor = '';
    });
};

let observer = setupObserver();

document.addEventListener('click', (e) => {
    const label = e.target.closest('label');
    const select = e.target.closest('select.select__select');
    
    if ((label || select) && !isDisabled) {
        clearTimeout(disableTimeout);
        clearTimeout(forceEnableTimeout);

        const elements = document.querySelectorAll('label, select.select__select');
        elements.forEach(el => {
            el.style.pointerEvents = 'none';
            el.style.cursor = 'wait';
        });

        isDisabled = true;

        if (observer) {
            observer.disconnect();
            observer = setupObserver();
        }

        disableTimeout = setTimeout(() => {
            enableElements();
        }, 700);

        forceEnableTimeout = setTimeout(() => {
            enableElements();
        }, 2000);
    }
}, true);

// Force enable on page events
['visibilitychange', 'pageshow'].forEach(event => {
    document.addEventListener(event, () => {
        enableElements();
    });
});